import { render, staticRenderFns } from "./secretset.vue?vue&type=template&id=da8c3298&scoped=true"
import script from "./secretset.vue?vue&type=script&lang=js"
export * from "./secretset.vue?vue&type=script&lang=js"
import style0 from "./secretset.vue?vue&type=style&index=0&id=da8c3298&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da8c3298",
  null
  
)

export default component.exports